import LessonStore from '../../stores/LessonStore'
import React, { useCallback, useEffect, useState } from 'react'
import { AssignmentUploaderEl } from './elements'
import ReactPlayer from 'react-player'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import Button from '../../../../../../../../../Components/Buttons/Button'
import VideoRecord from '../../../../../../../../../Modules/videoRecord'
import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'
import ms from 'ms'
import { notify } from '../../../../../../../../../Helpers/Notifications'
import { H4, H5, Text } from '../../../../../../../../../Styles/typography'

const AssignmentUploader = () => {
  const {
    data: { type, submission, registrationType },
    saveAssignmentSubmission,
  } = LessonStore.useContainer()
  const [videoBlob, setVideoBlob] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const uppy = new Uppy({
    debug: true,
    autoProceed: true,
    restrictions: {
      maxFileSize: 50 * 1024 * 1024,
      maxNumberOfFiles: 1,
      allowedFileTypes: ['video/*'],
    },
    onBeforeUpload: () => {
      setSubmitting(true)
    },
  }).use(AwsS3, {
    timeout: ms('5 minute'),
    companionUrl: process.env.REACT_APP_API_URL,
  })

  const addFile = useCallback(
    (file) => {
      try {
        uppy.addFile({
          name: file.name,
          type: file.type,
          data: file,
        })
        return true
      } catch (err) {
        notify('error', err.message)
      }
    },
    [uppy],
  )

  useEffect(() => {
    uppy
      .on('upload-success', async (file, response) => {
        await saveAssignmentSubmission(response.uploadURL)
        setSubmitting(false)
      })
      .on('upload-error', (file, error) => {
        notify('error', error.message)
        setSubmitting(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uppy])

  return type !== 'ASSIGNMENT' ? null : (
    <AssignmentUploaderEl>
      {registrationType !== 'CERTIFICATION' ? (
        <div className='content'>
          <H5 style={{ textAlign: 'center', maxWidth: '20em' }}>
            Assignments are available for certification registrations only.
          </H5>
        </div>
      ) : submission ? (
        <div className='content'>
          <H4 bold>Assignment Submitted</H4>
          <div style={{ width: '100%', marginBottom: '1em' }}>
            <ReactPlayer url={submission.url} controls width={'100%'} />
          </div>
          {!submission.review ? (
            <p>
              Your response has been submitted and is pending review by the
              teacher. <br /> You can check the response here once it is
              available.
            </p>
          ) : (
            <p>Your submission has been reviewed by the teacher.</p>
          )}

          {Boolean(submission.review) && (
            <div className='review_info'>
              <div className='review__content'>
                <Text>
                  <strong>Review:</strong> {submission.review?.message}
                </Text>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className='content'>
          {videoBlob ? (
            <>
              <ReactPlayer
                url={URL.createObjectURL(videoBlob)}
                controls
                playing
                width={'100%'}
              />
              <div className='action-btns'>
                <div className='retake-btn' onClick={() => setVideoBlob(null)}>
                  <DeleteOutlineIcon /> Retake
                </div>
                <Button
                  type='primary'
                  onClick={() => addFile(videoBlob)}
                  disabled={submitting}
                  name={submitting ? 'Uploading...' : 'Proceed'}
                />
              </div>
            </>
          ) : (
            <VideoRecord
              onSubmit={(value) => setVideoBlob(value)}
              videoBlob={videoBlob}
              size_limit={50 * 1024 * 1024}
              maxDuration={2.5 * 60 * 1000}
            />
          )}
        </div>
      )}
    </AssignmentUploaderEl>
  )
}

export default AssignmentUploader
